export default __webpack_public_path__ + "static/media/form.6c39adac.png";